import * as React from 'react';

import { FilterItemCheckbox, IconSolidStar } from '@notino/react-styleguide';

import { useTrackingContext } from '@context/tracking/TrackingContext';

import {
  useReviewFilterActions,
  useReviewFiltersStore,
} from '../../../Stores/filtersStore';
import { trackFiltration } from '../../tracking';

import { RatingFilterContentWrapper, StarsWrapper, Stars } from './styled';

function renderStars(count: number) {
  return (
    <>
      {Array.from({ length: 5 }, (_, index) => (
        <span key={`${count}-star-${index + 1}`}>
          <IconSolidStar
            color={index + 1 <= count ? 'icon.primary' : 'icon.disabled'}
            width="1rem"
            height="1rem"
          />
        </span>
      ))}
    </>
  );
}

export const RatingFilterContent: React.FC = () => {
  const selections = useReviewFiltersStore(
    (state) => state.temporarySelections
  );
  const { toggleSelection } = useReviewFilterActions();
  const rating = useReviewFiltersStore((state) => state.filtersData)?.rating;

  const { getTimeFromInit } = useTrackingContext();

  if (!rating) {
    return null;
  }

  const onChange = (stars: number) => {
    toggleSelection(stars);
    trackFiltration({
      interaction: selections.includes(stars) ? 'click_remove' : 'click_add',
      timing: getTimeFromInit(),
      name: String(stars),
      action: 'filtration_used',
      type: 'ratings',
    });
  };

  const buckets = [
    { stars: 5, value: rating.fiveStar },
    { stars: 4, value: rating.fourStar },
    { stars: 3, value: rating.threeStar },
    { stars: 2, value: rating.twoStar },
    { stars: 1, value: rating.oneStar },
  ];

  return (
    <RatingFilterContentWrapper>
      {buckets
        .filter(({ value }) => (value ?? 0) > 0)
        .map(({ stars, value }) => (
          <div key={stars}>
            <FilterItemCheckbox
              count={value ?? undefined}
              isChecked={selections.includes(stars)}
              onChange={() => onChange(stars)}
            >
              <StarsWrapper>
                <Stars>{renderStars(stars)}</Stars>

                <span>{stars}*</span>
              </StarsWrapper>
            </FilterItemCheckbox>
          </div>
        ))}
    </RatingFilterContentWrapper>
  );
};
